import { SharedState } from '@trello/shared-state';

const initialState: {
  activeIndex: number | null;
  isLoading: boolean;
  traceId?: string;
  proposedEventsViewed?: string[];
} = {
  activeIndex: null,
  isLoading: false,
  traceId: undefined,
  proposedEventsViewed: [],
};

export const smartScheduledCardsSharedState = new SharedState<
  typeof initialState
>(initialState);
